module.exports = __webpack_public_path__ + "img/edit.60bee6d1.svg";